import type { ReactNode } from 'react';
import { BearAuthProvider } from '@bear-auth/react';

import { env } from '@/env';

import { bearAuthActions } from '../../services/bear-auth/config';
import { bearAuthId, demoBearAuthId } from '../../services/bear-auth/create';
import { AuthLoader } from '../AuthLoader';

export interface AuthProviderProps {
    children: ReactNode;
}

export const AuthProvider = ({ children }: AuthProviderProps) => {
    if (env.VITE_DEMO) {
        return (
            <BearAuthProvider
                id={demoBearAuthId}
                actions={{
                    logout: bearAuthActions.logout,
                    refetchAuthInfo: bearAuthActions.fetchAuthInfo,
                }}
                loader={<AuthLoader />}
            >
                {children}
            </BearAuthProvider>
        );
    }

    return (
        <BearAuthProvider
            id={bearAuthId}
            actions={{
                logout: bearAuthActions.logout,
                refetchAuthInfo: bearAuthActions.fetchAuthInfo,
                // @ts-expect-error
                refreshToken: bearAuthActions.refreshToken,
            }}
            loader={<AuthLoader />}
        >
            {children}
        </BearAuthProvider>
    );
};
